export default __webpack_public_path__ + "static/media/news-14.82460441.png";